import React from 'react';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    pain: 'Horas buscando material cada semana',
    solution: '10 minutos. Todo listo.'
  }, {
    pain: 'Ejercicios genéricos copiados de internet',
    solution: '+120 actividades graficadas por nivel'
  }, {
    pain: 'Sin sistema claro para cada nivel',
    solution: 'Estructura clara A1 → C2'
  }, {
    pain: 'Alumnos viajeros que no sabés cómo cobrar',
    solution: 'Curso de 4 clases listo para vender'
  }, {
    pain: 'Horas corrigiendo producciones escritas',
    solution: 'Corrección visual en 60 segundos'
  }, {
    pain: 'Material que parece "casero" y resta autoridad',
    solution: 'PDFs profesionales que generan confianza y justifican tu precio'
  }, {
    pain: 'Domingo a la noche improvisando la clase del lunes',
    solution: 'Llegás a clase con todo resuelto'
  }];
  return <section className="py-20 bg-white" data-id="element-54">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-57">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-sm" data-id="element-58">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-59">
            <div className="p-6 text-center font-bold text-gray-500 uppercase tracking-wider text-sm" data-id="element-60">
              Sin ITALIANO 360
            </div>
            <div className="p-6 text-center font-bold text-brand-green uppercase tracking-wider text-sm bg-brand-green/5" data-id="element-61">
              Con ITALIANO 360
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-62">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-63">
                <div className="p-6 flex items-start text-gray-600 bg-white" data-id="element-64">
                  <X className="w-5 h-5 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-65" />
                  <span data-id="element-66">{row.pain}</span>
                </div>
                <div className="p-6 flex items-start text-[#1A1A1A] font-medium bg-brand-green/5" data-id="element-67">
                  <Check className="w-5 h-5 text-brand-green mr-3 flex-shrink-0 mt-0.5" data-id="element-68" />
                  <span data-id="element-69">{row.solution}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-70">
          <p className="text-xl font-serif italic text-gray-600" data-id="element-71">
            El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
          </p>
        </div>
      </div>
    </section>;
}